import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, role }) => {
  // Get authentication state from localStorage
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  
  // Check if user is authenticated and has the correct role
  const isAuthenticated = !!token;
  const hasCorrectRole = userRole === role;
  
  if (!isAuthenticated) {
    // Redirect to appropriate login page based on role
    if (role === 'admin') {
      return <Navigate to="/admin/login" replace />;
    } else if (role === 'coordinator') {
      return <Navigate to="/coordinator/login" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }
  
  if (!hasCorrectRole) {
    // Redirect to appropriate dashboard or login page
    if (userRole === 'admin') {
      return <Navigate to="/admin" replace />;
    } else if (userRole === 'coordinator') {
      return <Navigate to="/coordinator" replace />;
    } else {
      return <Navigate to="/" replace />;
    }
  }
  
  // If authenticated and has correct role, render the children
  return children;
};

export default PrivateRoute;
